import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import VerificationMethod from '@/components/auth/VerificationMethod';
import VerificationCode from '@/components/auth/VerificationCode';

const VerifyAccount = () => {
  const { user } = useSelector(state => state.auth);
  const navigate = useNavigate();
  const [verificationMethod, setVerificationMethod] = useState(null);

  useEffect(() => {
    if (!user) {
      navigate('/login');
      return;
    }

    if (user.hasVerifiedBoth()) {
      navigate('/dashboard');
    }

    // Check if user already selected a verification method
    if (user.verification_method) {
      setVerificationMethod(user.verification_method);
    }
  }, [user, navigate]);

  if (!user) {
    return null;
  }

  if (verificationMethod) {
    return <VerificationCode user={user} method={verificationMethod} />;
  }

  return <VerificationMethod user={user} />;
};

export default VerifyAccount;